module.exports = __webpack_public_path__ + "static/media/54_1120.96422414.webp";